import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Table, Button } from "reactstrap";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import PostAddIcon from "@material-ui/icons/PostAdd";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import CancelIcon from "@material-ui/icons/Cancel";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import Modal from "@material-ui/core/Modal";
import Checkbox from "@material-ui/core/Checkbox";
import ModalTheme from "../../../../../shared/components/Modal";
import history from "../../../../../history";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useModalAlert } from "../../../../GeneralComponents";

const listModuleInit = [
  { codigo: "P", nombre: "Perfiles", value: 1 },
  { codigo: "U", nombre: "Usuarios", value: 2 },
  { codigo: "CP", nombre: "Creación y almacenamiento de documentos", value: 3 },
  { codigo: "R", nombre: "Roles", value: 4 },
  { codigo: "HISM", nombre: "Tablas de retencion documental -TRD ", value: 5 },
  { codigo: "HISF", nombre: "Consulta de documentos", value: 6 },
  { codigo: "GD", nombre: "Gestión de documento", value: 7 },
  { codigo: "RAD", nombre: "Radicación", value: 8 },
  { codigo: "IND", nombre: "Indicadores", value: 9 },
  { codigo: "REP", nombre: "Reportes", value: 10 },
  { codigo: "C", nombre: "Cargos", value: 11 },
];

const FormAddModule = ({ profile }) => {
  const [newModule, setNewModule] = useState([]); //Modulos del perfil
  const [listModules, setListModules] = useState([]); //Todos los modulos
  const addServices = [];
  const [openModal, setOpenModal] = useState(false);
  const [newModal, setNewModal] = useState(false);
  const [create, setCreate] = useState(false);
  const [update, setUpdate] = useState(false);
  const [delet, setDelet] = useState(true);
  const [read, setRead] = useState(false);
  const { showModalAlert } = useModalAlert();

  const fetchAccessModules = (id_perfil) => {
    return new Promise((resolve, reject) => {
      var data = {
        id_perfil: id_perfil,
        nombre: "0",
      };
      fetch(process.env.REACT_APP_PUBLIC_URL + "perfiles/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.existe) {
            var AddedModules = [];
            var notAddedModules = listModuleInit;
            var moduleListReduce = [];
            if (data.contenido[0].perfil !== null) {
              data.contenido[0].perfil.modulos.map((modulo) => {
                var newElement = listModuleInit.find(
                  (elementModule) => elementModule.value === modulo,
                );
                AddedModules.push(newElement);
                return null;
              });

              notAddedModules.forEach((mod) => {
                let evaluate = evaluatesCon(mod, AddedModules);
                if (!evaluate) {
                  moduleListReduce.push(mod);
                }
              });
            }
            resolve({
              addedModules: AddedModules,
              notAddedModules: moduleListReduce,
            });
          } else {
            resolve({ addedModules: [], notAddedModules: listModuleInit });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  const evaluatesCon = (obj, arr) => {
    let resul = arr.some((mod) => mod.value === obj.value);
    return resul;
  };

  const evaluateModules = (AddedModules, notAddedModules) => {
    for (let i = 0; i < AddedModules.length; i++) {
      const elementi = AddedModules[i];
      for (let k = 0; k < notAddedModules.length; k++) {
        const elementk = notAddedModules[k];
        if (elementi.value !== elementk.value) {
          return elementk;
        }
      }
    }
  };
  const removeDuplicates = (originalArray, prop) => {
    var newArray = [];
    var lookupObject = {};

    for (var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  };

  const saveModules = () => {
    var AddModules = [];
    newModule.map((module, index) => {
      if (module !== undefined && module !== null) {
        AddModules.push(module.value);
        addServices.push(module.value + "." + (index + 1));
      }
    });

    var dataProfile = {
      id_perfil: profile.id_perfil,
      nombre: profile.nombre,
      codigo: profile.codigo,
      perfil: {
        modulos: AddModules,
        servicios: addServices,
      },
    };
    console.log(dataProfile);
    fetch(process.env.REACT_APP_PUBLIC_URL + "perfiles/update", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataProfile),
    })
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        showModalAlert("success", "Modulo agregado correctamente");
        history.push({
          pathname: process.env.PUBLIC_URL + "/config/manage-profile",
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  useEffect(() => {
    async function consultAccess() {
      try {
        var { addedModules, notAddedModules } = await fetchAccessModules(
          profile.id_perfil,
        );
        setNewModule(addedModules);
        setListModules(notAddedModules);
      } catch (error) {
        console.log(error);
      }
    }
    consultAccess();
  }, []);

  const tableDataNewModule = {
    tableHeaderData: [
      {
        Header: "Código",
        accessor: "codigo",
        disableGlobalFilter: true,
        width: 65,
      },
      {
        Header: "Nombre del módulo",
        accessor: "nombre",
      },
      {
        Header: "Opciones",
        accessor: "opciones",
      },
    ],
    tableRowsData: newModule,
  };

  const tableDataListModules = {
    tableHeaderData: [
      {
        Header: "Código",
        accessor: "codigo",
        disableGlobalFilter: true,
        width: 65,
      },
      {
        Header: "Nombre del módulo",
        accessor: "nombre",
      },
      {
        Header: "Opciones",
        accessor: "opciones",
      },
    ],
    tableRowsData: listModules,
  };

  useEffect(() => {}, [tableDataListModules]);

  const addPermisions = () => {
    let AddModules = [];
    newModule.map((module) => {
      AddModules.push(module.value);
    });

    let dataProfile = {
      id_perfil: profile.id_perfil,
      nombre: profile.nombre,
      perfil: {
        modulos: AddModules,
        servicios: addServices,
      },
    };
    console.log(dataProfile);

    fetch(process.env.REACT_APP_PUBLIC_URL + "perfiles/addpermisos", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataProfile),
    })
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        console.log(data);
        setNewModal(true);
        //alert(data)
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const getCreate = () => {
    let tempServs = [];

    if (!create) {
      newModule.map((module) => {
        addServices.push(module.value + ".1");
      });
      setCreate(true);
    } else {
      tempServs = addServices;

      for (let i = 0; i < tempServs.length; i++) {
        if (
          addServices[i].substr(
            addServices[i].length - 2,
            addServices[i].length - 1,
          ) === ".1"
        ) {
          addServices.splice(i, 1);
          i--;
        }
      }
      setCreate(false);
    }
  };

  const getUpdate = () => {
    let tempServs = [];

    if (!update) {
      newModule.map((module) => {
        addServices.push(module.value + ".2");
      });
      setUpdate(true);
    } else {
      tempServs = addServices;

      for (let i = 0; i < tempServs.length; i++) {
        if (
          addServices[i].substr(
            addServices[i].length - 2,
            addServices[i].length - 1,
          ) === ".2"
        ) {
          addServices.splice(i, 1);
          i--;
        }
      }
      setUpdate(false);
    }
  };

  const getDelet = () => {
    let tempServs = [];

    if (!delet) {
      newModule.map((module) => {
        addServices.push(module.value + ".3");
      });
      setDelet(true);
    } else {
      tempServs = addServices;

      for (let i = 0; i < tempServs.length; i++) {
        if (
          addServices[i].substr(
            addServices[i].length - 2,
            addServices[i].length - 1,
          ) === ".3"
        ) {
          addServices.splice(i, 1);
          i--;
        }
      }
      setDelet(false);
    }
  };

  const getRead = () => {
    let tempServs = [];

    if (!read) {
      newModule.map((module) => {
        addServices.push(module.value + ".4");
      });
      setRead(true);
    } else {
      tempServs = addServices;

      for (let i = 0; i < tempServs.length; i++) {
        if (
          addServices[i].substr(
            addServices[i].length - 2,
            addServices[i].length - 1,
          ) === ".4"
        ) {
          addServices.splice(i, 1);
          i--;
        }
      }
      setRead(false);
    }
  };

  return (
    <>
      {/*<DataReactTable title={'Nuevo modulo'} reactTableData={reactTableData} ReactTableActions={ReactTableActions} />
                        <DataReactTable title={'Modulos'} reactTableData={reactTableData} ReactTableActions={ReactTableActions} />*/}
      <Col md={12} lg={12} xl={6}>
        <Button
          style={{ marginBottom: 20 }}
          color="primary"
          size="sm"
          onClick={() => {
            history.push({
              pathname: process.env.PUBLIC_URL + "/config/manage-profile",
            });
          }}
        >
          <ArrowBackIcon />
        </Button>
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text">
                Nuevos modulos perfil {profile.nombre}
              </h5>
            </div>
            <div>
              <Button
                style={{ marginTop: 20 }}
                color="primary"
                onClick={() => {
                  saveModules();
                }}
              >
                Guardar
              </Button>
            </div>
            <Table responsive hover striped>
              <thead>
                <tr>
                  {tableDataNewModule.tableHeaderData.map((item) => (
                    <th style={{backgroundColor: "#C4C4C4"}} key={item.Header}>{item.Header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tableDataNewModule.tableRowsData.map((item, index) => (
                  <React.Fragment key={index}>
                    {item != undefined ? (
                        <tr key={index}>
                          <td>{item.codigo}</td>
                          <td>{item.nombre}</td>
                          <td>
                            <Tooltip title="Eliminar modulo">
                              <IconButton
                                aria-label="delete-module"
                                style={{ padding: 2 }}
                                onClick={() => {
                                  console.log(
                                    newModule.filter(
                                      (module) => module.value === item.value,
                                    ),
                                  );
                                  var modulesNew = newModule.filter(
                                    (module) => module.value !== item.value,
                                  );
                                  var modulesOld = [
                                    ...listModules,
                                    newModule.filter(
                                      (module) => module.value === item.value,
                                    )[0],
                                  ];
                                  console.log(modulesNew);
                                  setNewModule(modulesNew);
                                  setListModules(modulesOld);
                                }}
                              >
                                <DeleteForeverIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Inactivar modulo">
                              <IconButton
                                aria-label="disable-module"
                                style={{ padding: 2 }}
                                onClick={() => {}}
                              >
                                <CancelIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Asignar evento">
                              <IconButton
                                aria-label="asign-event"
                                style={{ padding: 2 }}
                                onClick={() => {
                                  setOpenModal(true);
                                }}
                              >
                                <EventAvailableIcon />
                              </IconButton>
                            </Tooltip>
                          </td>
                      </tr>
                    ) : null}
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>
      <Col md={12} lg={12} xl={6}>
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text">Seleccionar modulos</h5>
            </div>
            <Table responsive hover striped>
              <thead>
                <tr>
                  {tableDataListModules.tableHeaderData.map((item) => (
                    <th style={{backgroundColor: "#C4C4C4"}} key={item.Header}>{item.Header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tableDataListModules.tableRowsData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{item.codigo}</td>
                    <td>{item.nombre}</td>
                    <td>
                      <Tooltip title="Agregar modulo">
                        <IconButton
                          aria-label="add-modules"
                          style={{ padding: 2 }}
                          onClick={() => {
                            var modulesOld = listModules.filter(
                              (module) => module.value !== item.value,
                            );
                            var modulesNew = [
                              ...newModule,
                              listModules.filter(
                                (module) => module.value === item.value,
                              )[0],
                            ];
                            console.log(modulesNew);
                            setNewModule(modulesNew);
                            setListModules(modulesOld);
                          }}
                        >
                          <PostAddIcon />
                        </IconButton>
                      </Tooltip>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <Modal
              open={openModal}
              onClose={() => {
                setOpenModal(false);
              }}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              style={{ zIndex: 1000 }}
            >
              <div className="paperAppointment">
                <div>
                  <h4>Agregar Servicios al Modulo</h4>

                  <div style={{ margin: 20 }}>
                    <Checkbox onChange={getCreate} /> Crear
                    <Checkbox onChange={getUpdate} /> Actualizar
                    <Checkbox onChange={getDelet} /> Eliminar
                    <Checkbox onChange={getRead} /> Leer
                  </div>

                  <Button
                    style={{ marginTop: 20 }}
                    variant="contained"
                    color="primary"
                    onClick={addPermisions}
                  >
                    Guardar
                  </Button>
                </div>
              </div>
            </Modal>
            <ModalTheme
              color="succes"
              title="Actualizado con exito"
              modal={newModal}
              onOk={() => setNewModal(!newModal)}
              toggle={() => setNewModal(!newModal)}
            />
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default FormAddModule;
